

export class SortingGroup {
    constructor(order, items, placeholder) {
        this.order = order;
        this.items = items;
        this.placeholder = placeholder;
    }
}